import { render, staticRenderFns } from "./update-account.vue?vue&type=template&id=0e37296f&"
import script from "./update-account.vue?vue&type=script&lang=js&"
export * from "./update-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports